<template lang="pug">
v-toolbar.Poppins(color='white light-1', fixed, light, app, flat, style="box-shadow: inset 0px -2px 0px 0px rgba(204,204,209,1)!important; top: var(--env-banner-height, 0px);")
  v-toolbar-side-icon(@click.stop='$root.pedido_mobile = null;', left, v-if="$root.pedido_mobile", color="gray")
    v-icon arrow_back_ios
  v-toolbar-side-icon(@click.stop='handleDrawerToggle', left, v-else)
      v-icon(color="gray") menu
  v-toolbar-title.hidden-md-and-up(v-if="$root.pedido_mobile") Pedido {{ $root.pedido_mobile.id }}

  v-menu(offset-y, origin='center center', :nudge-bottom='10', transition='scale-transition',)
    v-btn.btnNomeEstab(flat, color="gray", slot='activator', @click="openDialogSelecaoLoja()")
      v-layout.dadosEstabelecimento(row)
        v-flex(v-if="estabelecimentoSelecionado", style="flex-basis: 0!important; flex-grow: 0;")
          v-icon(:color="estabelecimentoAberto ? 'primary' : 'orange'", small).fa fa-circle
        v-flex.text-xs-left.d-flex
          label.textSelectedStore(v-if="!estabelecimentoSelecionado").font-weight-bold Todas as lojas ({{estabelecimentos.length}})
          label.textSelectedStore(v-if="estabelecimentoSelecionado").font-weight-bold {{estabelecimentoSelecionado.nome}}
            br
            label.subTextSelectedStore(v-if="estabelecimentoSelecionado").caption {{estabelecimentoSelecionado.localidade}} - {{estabelecimentoSelecionado.estado}}
        v-flex.text-xs-left
          v-icon(large, v-if="estabelecimentos.length > 1") arrow_drop_down

  v-spacer

  v-btn.btnDelivery(:class="{'aberto': estabelecimentoAberto, 'fechado': !estabelecimentoAberto}", :loading="loading", depressed, color="white" @click="estabelecimentoAberto ? openDialogCloseTimer(estabelecimentoSelecionado) : openLoja(estabelecimentoSelecionado)", v-if="estabelecimentoSelecionado")
    .body-1.font-weight-bold(:class="{'red--text': estabelecimentoAberto, 'primary--text': !estabelecimentoAberto}") {{ estabelecimentoAberto ? 'Fechar' : 'Abrir' }} loja

  v-menu(offset-y, origin='center center', :nudge-bottom='10', transition='scale-transition', v-if="!estabelecimentoSelecionado && estabelecimentos.length > 1")
    v-btn(flat, slot='activator', @click="openDialogOpenClose()", color="gray")
      v-layout(row, wrap)
        v-flex.md12.text-xs-right
          .caption Status
          label.font-weight-bold(v-if="estabelecimentos.length > 1") {{ getAbertos() }} / {{ estabelecimentos.length }} abertos
          label.font-weight-bold(v-else) {{ aberto ? 'ABERTO' : 'FECHADO' }}

  v-menu(offset-y, origin='center center', :nudge-bottom='10', transition='scale-transition', v-if="$root.user && !$root.pedido_mobile")
    v-btn(style="text-transform: none!important" flat, color="gray", slot='activator')
      | Olá, {{ $root.user.nome.split(' ').length ? $root.user.nome.split(' ')[0] != '' ? $root.user.nome.split(' ')[0] : $root.user.nome.split(' ').length > 1 ? $root.user.nome.split(' ')[1] : $root.user.nome : $root.user.nome }}
      v-icon(dark) arrow_drop_down
    v-list.pa-0
      v-list-tile(v-for='(item,index) in itemsVisiveis', :to='!item.href ? { name: item.name } : null', :href='item.href', @click='item.click', ripple='ripple', :disabled='item.disabled', :target='item.target', rel='noopener', :key='index')
        v-list-tile-action(v-if='item.icon')
          v-icon {{ item.icon }}
        v-list-tile-content
          v-list-tile-title {{ item.title }}

  DialogSelecaoLoja(ref="dialogSelecaoLoja", @refresh="refresh")
  DialogCloseTimer(ref="dialogCloseTimer", @refresh="refresh")
  DialogTempoEntrega(ref="dialogTempoEntrega", @refresh="refresh")
  DialogOpenClose(ref="dialogOpenClose", @refresh="refresh")
</template>

<script>
import _ from "lodash";
import Util from "@/util";
import DialogSelecaoLoja from '@/components/dialog/DialogSelecaoLoja';
import DialogCloseTimer from '@/components/dialog/DialogCloseTimer';
import DialogTempoEntrega from '@/components/dialog/DialogTempoEntrega';
import DialogOpenClose from '@/components/dialog/DialogOpenClose';

export default {
  name: "app-toolbar",
  components: {
    DialogSelecaoLoja,
    DialogCloseTimer,
    DialogTempoEntrega,
    DialogOpenClose
  },
  data: () => ({
    items: [
      {
        icon: "account_circle",
        name: "MeusDados",
        title: "Meus Dados",
        click: e => {
        },
      },
      {
        icon: "exit_to_app",
        href: "#",
        title: "Logout",
        click: e => {
          window.getApp.$emit("APP_LOGOUT");
        },
      }
    ],
    loading: false,
    loadingRecessos: false,
    recessos: null,
    recessosAgendados: [],
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
    abertos () {
      return _.countBy(this.$root.estabelecimentos, e => e.delivery[0].aberto == 1).true || 0;
    },
    aberto () {
      return this.$root.estabelecimentos.length ? this.$root.estabelecimentos[0].delivery[0].aberto : 0;
    },
    estabelecimentos(){
      return this.$root.estabelecimentos;
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    estabelecimentoAberto(){
      const delivery = this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.delivery ? this.$root.estabelecimentoSelecionado.delivery[0] : null
      return delivery && delivery.aberto == 1 ? true : false;
    },
    // Durante o onboarding o parceiro fica restrito à tela da etapa da vez, então
    // some com o que navega para fora dela. Logout continua sempre disponível.
    itemsVisiveis(){
      if (!this.$root.isOnboardingPendente) return this.items;
      return this.items.filter(item => item.name !== 'MeusDados');
    },
  },
  mounted () {
    this.initEstabelecimento();
    window.getApp.$on("SELECT_ESTABELECIMENTO", () => {
      this.openDialogSelecaoLoja();
    });
    window.getApp.$on("OPEN_DIALOG_CLOSE_TIMER", (estabelecimento) => {
      this.openDialogCloseTimer(estabelecimento);
    });
  },
  created () {
    window.getApp.$on("UPDATE_DELIVERY_TOOLBAR", async (estabelecimento_id) => {
      window.getApp.$emit('UPDATE_DELIVERY_LIST');
      this.refresh(estabelecimento_id);
      this.$forceUpdate();
      console.log('UPDATE_DELIVERY_TOOLBAR');
    });
  },
  methods: {

    getAbertos(){
      return _.countBy(this.$root.estabelecimentos, e => e.delivery[0].aberto == 1).true || 0;
    },

    // estabelecimentoAberto(){
    //   const delivery = this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.delivery ? this.$root.estabelecimentoSelecionado.delivery[0] : null
    //   return delivery && delivery.aberto == 1 ? true : false;
    // },

    getTempoEntrega(){
      const delivery = this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.delivery ? this.$root.estabelecimentoSelecionado.delivery[0] : null
      return delivery ? delivery.tempo_entrega : '';
    },

    openDialogSelecaoLoja(){
      if (this.$refs.dialogSelecaoLoja) {
        this.$refs.dialogSelecaoLoja.open(this.estabelecimentoSelecionado);
      }
    },

    openDialogCloseTimer(estabelecimento){
      this.$refs.dialogCloseTimer.open(estabelecimento || this.estabelecimentoSelecionado);
    },

    openDialogOpenClose(){
      this.$refs.dialogOpenClose.open();
    },

    openDialogTempoEntrega(){
      this.$refs.dialogTempoEntrega.open(this.estabelecimentoSelecionado);
    },

    async openLoja(){
      const isPendente = (this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.vendas || []).some(v =>
        v.status == this.$root.enums.STATUS.VENDA_PENDENTE
      );
      // Só bloqueia se também tiver registro de onboarding criado pelo admin
      if (isPendente && this.$root.onboardingData && this.$root.onboardingData.id) {
        window.getApp.$emit('OPEN_ONBOARDING');
        return;
      }
      try{
        this.loading = true;
        const estabelecimento = _.cloneDeep(this.estabelecimentoSelecionado);
        const delivery = estabelecimento.delivery[0];
        const response = await this.$axios.post('/abrir', delivery);
        estabelecimento.delivery[0] = response.data;
        this.$root.updateEstabelecimento(estabelecimento);
        this.refresh(estabelecimento.id);
        this.loading = false;
      }catch(error){
        const err = error.response && error.response.data ? error.response.data.error : null;
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err || 'Não foi possível abrir a loja. Por favor, tente novamente.' });
        this.loading = false;
      }
    },

    refresh(estabelecimento_id){
      this.getRecessosVigentes(estabelecimento_id);
      this.getRecessosAgendados(estabelecimento_id);
      this.$forceUpdate()
    },

    async getRecessosAgendados(estabelecimento_id){
      try {
        if (!this.estabelecimentoSelecionado || estabelecimento_id != this.estabelecimentoSelecionado.id) return;
        const { data } = await this.$axios.get('/recesso-estabelecimento', {
          params: { estabelecimento_id: this.estabelecimentoSelecionado.id, ativo: 1 },
        });
        const agora = this.$dayjs();
        this.recessosAgendados = data.filter(r =>
          this.$dayjs(r.data_fim).isAfter(agora) && r.admin_estabelecimento_id
        );
        this.$root.agendamentosCount = this.recessosAgendados.length || 0;
      } catch (_) {
        this.recessosAgendados = [];
        this.$root.agendamentosCount = 0;
      }
    },

    initEstabelecimento(){
      if(this.estabelecimentos && this.estabelecimentos.length == 1){
        const estabelecimento = this.estabelecimentos[0];
        this.$store.dispatch('setEstabelecimentoSelecionado', estabelecimento);
      }else if(this.estabelecimentoSelecionado){
        const estabelecimento = _.find(this.estabelecimentos, (o)=>{
          return o.id == this.estabelecimentoSelecionado.id
        })
        this.$store.dispatch('setEstabelecimentoSelecionado', estabelecimento || null);
      }
      this.refresh(this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null);
    },

    async getRecessosVigentes(estabelecimento_id){
      try{
        if(!this.estabelecimentoSelecionado || estabelecimento_id != this.estabelecimentoSelecionado.id) return;
        const response = await this.$axios.get('/recessos-vigente', {
          params: {
            estabelecimento_id: this.estabelecimentoSelecionado.id
          }
        });
        const recessosVigentes = response.data;
        const estabelecimento = _.cloneDeep(this.estabelecimentoSelecionado);
        estabelecimento.recessosVigentes = recessosVigentes;
        this.$root.updateEstabelecimento(estabelecimento);

      }catch(error){
        console.error(error)
        const err = error.response && error.response.data ? error.response.data.error : null;
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err || 'Não foi possível abrir a loja. Por favor, tente novamente.' });
      }
    },

    handleDrawerToggle () {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },
  }
};
</script>

<style lang="scss" scoped>
.btnRecesso{
  height: 35px;
  border-radius: 7px;
}
.btnDelivery{
  height: 50px;
  border-radius: 7px;
}

.dadosEstabelecimento{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 10px;
  gap: 10px;
}
.btnNomeEstab{
  display: flex;
  align-items: left;
  justify-content: center;
  padding: 5px 10px;
}

.textSelectedStore{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15vw;
}

.aberto{
  background-color:rgba(255, 75, 75, 0.2)!important;
  color:rgba(255, 75, 75, 1)!important;
}

.fechado{
  background-color:rgba(29, 154, 89, 0.2)!important;
}

@media (max-width:900px) {
  .textSelectedStore{
    font-size: 12px!important;
    max-width: 300px!important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .subTextSelectedStore{
    font-size: 10px!important;
  }
}

</style>
<style lang="scss" >
.btnDelivery .v-btn__content{
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.Poppins{
  font-family: 'Poppins', 'Roboto', sans-serif!important;
}

.v-dialog {
  border-radius: 17px!important;
  border: 6px solid #d2d2d7!important;
  margin: 14px!important;
}

.v-dialog::-webkit-scrollbar {
    width: 0px;
}

.v-dialog::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
}

</style>
